module.exports = __webpack_public_path__ + "images/Asset 10@3x.png";